import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { cn } from '@/shared/lib';

import { isNavItemActive, MOBILE_LINKS } from './dashboardNav';

type DashboardMobileNavProps = {
  quickActionsOpen: boolean;
  onToggleQuickActions: () => void;
};

/** Bottom bar on the master dashboard, with the quick-action button in the middle. */
export const DashboardMobileNav = ({
  quickActionsOpen,
  onToggleQuickActions,
}: DashboardMobileNavProps) => {
  const { t } = useTranslation('app');
  const { pathname } = useLocation();

  const [first, second, third, fourth] = MOBILE_LINKS;

  const renderLink = ({ icon: Icon, labelKey, path }: (typeof MOBILE_LINKS)[number]) => {
    const active = isNavItemActive(pathname, path);
    return (
      <Link
        key={path}
        to={path}
        aria-current={active ? 'page' : undefined}
        className={cn(
          'flex flex-col items-center',
          active ? 'text-primary' : 'text-gray-400 transition-colors hover:text-dark',
        )}
      >
        <Icon size={24} />
        <span className="mt-1 text-[10px] font-medium">{t(labelKey)}</span>
      </Link>
    );
  };

  return (
    <div className="pb-safe fixed right-0 bottom-0 left-0 z-50 flex items-center justify-between border-t border-gray-100 bg-white px-6 py-3 md:hidden">
      {renderLink(first)}
      {renderLink(second)}

      <div className="relative -top-5">
        <button
          type="button"
          onClick={onToggleQuickActions}
          aria-expanded={quickActionsOpen}
          aria-label={t('quickActions.open')}
          className="rounded-full bg-primary p-4 text-white shadow-lg shadow-primary/30 transition-transform active:scale-95"
        >
          <Plus
            size={24}
            className={cn(
              'transition-transform duration-300',
              quickActionsOpen ? 'rotate-45' : 'rotate-0',
            )}
          />
        </button>
      </div>

      {renderLink(third)}
      {renderLink(fourth)}
    </div>
  );
};
